export default __webpack_public_path__ + "static/media/icon_select_course.45053557.jpg";